import { keyframes, styled } from '../../stitches.config.es.js';
var pulse = keyframes({
  "0%, 100%": {
    opacity: 1
  },
  "50%": {
    opacity: 0.5
  }
});
var ButtonLoader = styled("div", {
  animation: "".concat(pulse(), " 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"),
  background: "#F3F4F6",
  borderRadius: 4,
  height: 40
});
export { ButtonLoader };